<span class="badge line-height-100" [ngClass]="classes">
  <svg-icon *ngIf="icon && type !== 'notification' && badgeStyle !== 'notification' "
            [name]="icon"
            [svgStyle]="{ 'width.px': 16, 'height.px': 16, 'fill': 'currentColor' }"
            [ngStyle]="{ height: '16px' }"></svg-icon>

  <span class="badge__count"
        *ngIf="count > 0"
        [ngClass]="type !== 'notification' || !icon ? 'u-m0' : 'u-p0' "> {{ count }} </span>
  <span class="badge__icon" *ngIf="type === 'notification' && icon">
    <svg-icon [name]="icon"
              [svgStyle]="{ 'width.px': iconSize, 'height.px': iconSize, 'fill': 'currentColor' }"
              [ngStyle]="{ height: iconSize + 'px' }"></svg-icon>
  </span>
  <span class="badge__text text-16" *ngIf="type !== 'notification' || !icon ">
    {{ label }}
  </span>
</span>
